/**
 * RetentionRateCard — بطاقة «معدّل الاحتفاظ» الرئيسية (Phase 7g).
 *
 * إبراز القيمة الموجودة سابقًا كـ tile داخل MeasuredMetrics إلى بطاقة
 * مستقلة بارزة. لا تغيير حساب: تقرأ نفس الحقل retention_30d_pct من
 * /customer-metrics/team-summary. تتبع تاريخ الشريط المشترك (لا فرع —
 * غير مدعوم في team-summary).
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { resolvePreset } from "../DateRangePicker";
import { GRAIN_PRESET } from "./grainPreset";
import { useCustomerFilter } from "./CustomerFilterContext";

const TEAL = "#065F46";
const TEAL_SOFT = "#0F766E";

export const RetentionRateCard = () => {
  const shared = useCustomerFilter();
  const preset = resolvePreset(GRAIN_PRESET.week) || { from: "", to: "" };
  const from = shared?.from || preset.from;
  const to = shared?.to || preset.to;
  const [state, setState] = useState({ loading: true, err: null, data: null });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, err: null, data: null });
    api.get("/customer-metrics/team-summary", { params: { from, to } })
      .then((r) => { if (!cancelled) setState({ loading: false, err: null, data: r.data }); })
      .catch((e) => {
        if (cancelled) return;
        const msg = e?.response?.data?.detail || e?.message || "خطأ";
        setState({ loading: false, err: msg, data: null });
      });
    return () => { cancelled = true; };
  }, [from, to]);

  const d = state.data;
  const pct = d?.retention_30d_pct;
  const returned = d?.retention_returned;
  const cohort = d?.retention_cohort_size;

  return (
    <article data-testid="retention-rate-card" dir="rtl"
      style={{
        background: "#fff", border: "1px solid rgba(6,95,70,0.20)",
        borderRadius: 16, padding: "20px 24px", marginBottom: 16,
        boxShadow: "0 1px 3px rgba(6,95,70,0.06)",
      }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#3D2A1C" }}>
            🔁 معدّل الاحتفاظ
          </div>
          <div style={{ fontSize: 12, color: TEAL_SOFT, marginTop: 2 }}>
            نسبة عملاء الفترة السابقة الذين عادوا في الفترة الحالية (كوهورت 30 يوم)
          </div>
        </div>
        <div style={{ textAlign: "center", minWidth: 120 }}>
          <div data-testid="retention-rate-value"
            style={{ fontSize: 40, fontWeight: 900, color: TEAL, lineHeight: 1,
                     fontVariantNumeric: "lining-nums tabular-nums" }}>
            {state.loading ? "…" : (pct != null ? `${pct}%` : "—")}
          </div>
          {!state.loading && returned != null && cohort != null && (
            <div style={{ fontSize: 11, color: "#78716C", marginTop: 6 }}>
              {returned?.toLocaleString("en-US")} عادوا من {cohort?.toLocaleString("en-US")} عميل
            </div>
          )}
        </div>
      </div>
      {state.err && (
        <div data-testid="retention-rate-error"
          style={{ marginTop: 10, fontSize: 12, color: "#B45309" }}>
          تعذّر تحميل معدّل الاحتفاظ.
        </div>
      )}
    </article>
  );
};

export default RetentionRateCard;
